/* Voice audition page — 5 candidate narrators reading the same opening line.
 * Route: /voices
 */
import React from "react";

const SCRIPT = `"We can't control everything an investor sees. But we can change what they trust. Meet Nomsa. A first-time investor. Her adviser, James Smith, at ABC Wealth, sends her a new investment proposal — directly into her Altara wallet."`;

const VOICES = [
  { key: "A", id: "A_alice",     name: "Alice",     tag: "British · calm authority",     desc: "Mature, measured, minimal excitement — closest to the SA corporate narrator brief.", featured: true },
  { key: "B", id: "B_matilda",   name: "Matilda",   tag: "British · warm narrator",       desc: "Confident but understated; slightly more conversational than Alice." },
  { key: "C", id: "C_charlotte", name: "Charlotte", tag: "English · deep cinematic",      desc: "Deepest pitch of the five; contemplative, cinematic. (The voice in v1 of the journey.)" },
  { key: "D", id: "D_rachel",    name: "Rachel",    tag: "American · classic warm",       desc: "Gold-standard documentary voice; natural pauses, slow, warm." },
  { key: "E", id: "E_sarah",     name: "Sarah",     tag: "American · soft professional",  desc: "Slightly younger (30-ish); warm, low-key premium commercial feel." },
];

export default function VoiceAuditionPage() {
  return (
    <div className="min-h-screen" style={{ background: "#050914", color: "#F5F0E7" }} data-testid="voice-audition">
      <div className="mx-auto max-w-4xl px-6 py-14">
        <div className="mb-2 text-xs tracking-[0.35em]" style={{ color: "#C9A24A" }}>
          ALTARA · NARRATOR AUDITION
        </div>
        <h1 className="text-4xl font-extrabold mb-3" style={{ letterSpacing: -0.5 }}>
          Pick your journey narrator
        </h1>
        <p className="text-sm mb-8" style={{ color: "#B7B4A9" }}>
          Same script, same slower pace (stability 0.70, style 0.15) — different voice. Reply with the letter of the one that fits and I'll regenerate the full journey MP4.
        </p>

        <div className="rounded-xl p-5 mb-10" style={{ background: "rgba(201,162,74,0.06)", border: "1px solid rgba(201,162,74,0.25)" }}>
          <div className="text-[10px] tracking-[0.35em] mb-2" style={{ color: "#C9A24A" }}>SCRIPT</div>
          <p className="text-sm leading-relaxed" style={{ color: "#E3DFD3" }}>{SCRIPT}</p>
        </div>

        <div className="space-y-4">
          {VOICES.map((v) => (
            <div
              key={v.id}
              className="rounded-2xl p-5"
              style={{
                background: "rgba(255,255,255,0.03)",
                border: v.featured ? "1px solid rgba(201,162,74,0.55)" : "1px solid rgba(255,255,255,0.08)",
                boxShadow: v.featured ? "0 0 40px rgba(201,162,74,0.15)" : "none",
              }}
              data-testid={`voice-${v.id}`}
            >
              <div className="flex items-baseline justify-between mb-1">
                <div className="flex items-baseline gap-3">
                  <div className="font-mono text-xs" style={{ color: "#C9A24A" }}>{v.key}</div>
                  <div className="text-lg font-semibold">{v.name}</div>
                  <div className="text-xs" style={{ color: "#8C8878" }}>{v.tag}</div>
                </div>
                {v.featured && (
                  <div className="text-[10px] tracking-widest px-2 py-1 rounded" style={{ background: "rgba(201,162,74,0.18)", color: "#C9A24A" }}>
                    RECOMMENDED
                  </div>
                )}
              </div>
              <p className="text-xs mb-3" style={{ color: "#A9A69C" }}>{v.desc}</p>
              <audio
                controls
                preload="none"
                src={`/voice-samples/${v.id}.mp3`}
                data-testid={`audio-${v.id}`}
                style={{ width: "100%", height: 40 }}
              />
              <div className="mt-2 text-[11px]" style={{ color: "#6E6B62" }}>
                Direct link: <a href={`/voice-samples/${v.id}.mp3`} className="underline" style={{ color: "#C9A24A" }} target="_blank" rel="noreferrer">/voice-samples/{v.id}.mp3</a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-xs" style={{ color: "#6E6B62" }}>
          Tip · use headphones for the fairest comparison; laptop speakers under-represent Charlotte's lower register.
        </div>
      </div>
    </div>
  );
}
